Object.defineProperty(exports, "__esModule", { value: true });
exports.SDK_VERSION = '6.19.3';
//# sourceMappingURL=version.js.map